import jQuery from 'jquery';

const $ = jQuery;

const initHeroVideo = () => {
  const playBtn = $('.play-btn');
  const pauseBtn = $('.pause-btn');
  
  $(playBtn).on('click', function() {
    $('.hero-video').get(0).play();
    $('.hero-mobile-video').get(0).play();
    $(playBtn).hide();
    $(pauseBtn).show();
  });

  $(pauseBtn).on('click', function() {
    $('.hero-video').get(0).pause();
    $('.hero-mobile-video').get(0).pause();
    $(playBtn).show();
    $(pauseBtn).hide();
  });
};

export default initHeroVideo;
